import React, { useEffect, useState, useRef } from "react";

import WebBarChart from "../../../../../elements/barChart";

import "./style.scss";

const barColors = ["#FFA32E", "#E38029", "#FA8039", "#E6693C", "#FA684B"];

function Slide1(props) {
  const mounted = useRef();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (data.length > 0) {
        props.getData({
          type: "image",
          title: "Sales By Group Type",
          filter: {
            brands: props.filter.data.brands.map((brand) => brand.name),
            chains: props.filter.data.chains.map((chain) => chain.name),
            revCent: props.filter.data.revCent.map((revCent) => revCent.name),
            payType: props.filter.data.payType.map((payType) => payType.name),
            date: {
              start: props.filter.data.date.start,
              end: props.filter.data.date.end,
            },
          },
          body: {
            table: [
              {
                head: [["Reataurant name", "Total"]],
                body: [
                  ...data?.map((item) => [
                    item?.label,
                    `${item?.currency || "QAR"} ${item?.y?.toFixed(2)}`,
                  ]),
                ],
              },
            ],
            id: "exportPdf_Slide1",
          },
        });
      }
    }
  }, [props.export]);

  useEffect(() => {
    const slide1Data = Object.values(
      props.slideData.reduce(
        (a, c) => (
          (a[c.restaurant_name] = a[c.restaurant_name]
            ? ((a[c.restaurant_name].total += c.total), a[c.restaurant_name])
            : c),
          a
        ),
        {}
      )
    );

    const slide1DataF = slide1Data?.map((item, idx) => {
      const totalSales = item.total;
      const currency = item?.currency || "QAR";
      return {
        y: totalSales,
        value: totalSales,
        label: item.restaurant_name,
        name: item.restaurant_name,
        displayValue: `${currency} ${totalSales?.toFixed(2)}`,
        currency: currency,
        openSales: `${currency} 0.00`,
        closedSales: `${currency} ${totalSales?.toFixed(2)}`,
        targetValue: `${currency} 0.00`,
        color: barColors[idx % barColors.length],
      };
    });

    setData(slide1DataF);
  }, [props.slideData]);

  return (
    <div id={"exportPdf_Slide1"}>
      <div
        style={{
          height: Math.max(data.length * 60 || 0, 300),
          overflowY: "auto",
        }}
      >
        <WebBarChart chartData={data} />
      </div>
    </div>
  );
}

export default Slide1;
